import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DrawerLayout from '../../components/shared/DrawerLayout';
import ClaimDrawerBody from './ClaimDrawerBody';
import NestedDrawer from '../shared/NestedDrawer';
import { ViewMode } from '../../hooks/viewMode';
import { selectSelectedClaim } from '../../redux/store/userData/claims';
import { ViewType } from '../../hooks/useViewType';
import isDesktop from '../../utils/sizeHelpers';
import { closeClaimDrawerAndSetQueries } from '../../redux/store/ui/common';
import {
  selectViewMode,
  selectViewType,
} from '../../redux/store/ui/common/selectors';

const ClaimDrawer: React.FC = () => {
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);
  const selectedClaim = useSelector(selectSelectedClaim);
  const dispatch = useDispatch();

  const visible =
    (selectedClaim != null && isDesktop()) ||
    (selectedClaim != null && !isDesktop() && viewType !== ViewType.MAP);

  const handleOnClose = () => {
    dispatch(closeClaimDrawerAndSetQueries());
  };

  return (
    selectedClaim && (
      <DrawerLayout
        visible={visible}
        title={selectedClaim?.id || ''}
        body={<ClaimDrawerBody />}
        nestedDrawers={
          <>
            {viewMode !== ViewMode.VEHICLE && <NestedDrawer name="carEdit" />}
            {viewMode !== ViewMode.SHARE && <NestedDrawer name="trip" />}
            {viewMode !== ViewMode.CARE && <NestedDrawer name="care" />}
          </>
        }
        isClaimDrawer
        onReload={undefined}
        onClose={handleOnClose}
      />
    )
  );
};

export default ClaimDrawer;
